import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer id="contact" className="bg-gradient-to-br from-gray-800 via-gray-900 to-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-16">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <span className="text-2xl font-bold tracking-wide">AKTEN INC</span>
            </div>
            <p className="text-gray-400 mb-2">United States of America</p>
            <p className="text-gray-500 text-sm">
              US-based wholesale and marketplace operations company
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Wholesale & Distribution
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Marketplace Operations
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Fulfillment & Logistics
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#partnership" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Partnership
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm text-gray-400">
              <p>© 2025 AKTEN INC. All rights reserved.</p>
              <Link to="/privacy-policy" className="hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms-of-use" className="hover:text-white transition-colors cursor-pointer">
                Terms of Use
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              <a
                href="mailto:contact@akteninc.com"
                className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/akteninc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://x.com/aktenInc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com/akteninc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"
              >
                <img 
                  src="/site-images/43e89a265431b41e226f.png" 
                  alt="Instagram" 
                  className="w-5 h-5 object-contain brightness-0 invert"
                />
              </a>
              <a
                href="https://www.facebook.com/akteninc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"
              >
                <img 
                  src="/site-images/311eec5a7b1c16fe4ee5.png" 
                  alt="Facebook" 
                  className="w-5 h-5 object-contain brightness-0 invert"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
